// Katalogdaki sütunlar grup grup; tıklayınca seçime eklenir / çıkar; grup başlığında Tümü / Temizle
export default function ColumnPicker({ groups, cols, toggle, setMany, testid }) {
  const has = (k) => cols.some((c) => c.key === k);
  return (
    <div className="space-y-3" data-testid={`${testid}-catalog`}>
      <div className="text-[11px] font-bold uppercase tracking-wider text-slate-600">Kullanılabilir Sütunlar</div>
      {groups.map(([g, items]) => (
        <div key={g} data-testid={`${testid}-group-${g}`}>
          <div className="flex items-center gap-2 text-[11px] font-semibold text-slate-600 mb-1">
            {g} <span className="font-normal text-slate-400">{items.filter((c) => has(c.key)).length}/{items.length}</span>
            <button type="button" onClick={() => setMany(items, true)} className="underline font-normal" data-testid={`${testid}-group-${g}-all`}>Tümü</button>
            <button type="button" onClick={() => setMany(items, false)} className="underline font-normal" data-testid={`${testid}-group-${g}-none`}>Temizle</button>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5">
            {items.map((c) => (
              <label key={c.key} className={`flex items-center gap-2 text-xs px-2 py-1.5 rounded border cursor-pointer ${has(c.key) ? "border-emerald-400 bg-emerald-50" : "border-slate-200 hover:bg-slate-50"}`}>
                <input type="checkbox" checked={has(c.key)} onChange={() => toggle(c)} data-testid={`${testid}-col-${c.key}`} />{c.label}
              </label>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
